import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { isLoggedOnSelector } from '../recoil/selectors/isLoggedOnSelector';
import { allCoverablesAtom } from '../recoil/atoms/allCoverablesAtom';
import { allCoverablesOnsaAtom } from '../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../recoil/selectors/getOnsaCurrentProductSelector';
import { findCarWithMatchingProperty } from '../utils/coverablesUtil';

export const useSetVehicleInheritanceFields = (): {
    setVehicleInheritanceFields: () => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);
    const shoppingBasketCoverables = useRecoilValue(allCoverablesAtom);
    const onsaCoverables = useRecoilValue(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);

    const vehicleToInheritFrom = findCarWithMatchingProperty(
        shoppingBasketCoverables,
        onsaCoverables,
        currentProduct.fixedId,
        'ageOfOldestInHousehold'
    );
    const setVehicleInheritanceFields = async (): Promise<void> => {
        if (!vehicleToInheritFrom?.fixedId) {
            return;
        }

        await OnlineSalesUnauthenticated.setVehicleInheritanceFields(
            jobNumber,
            sessionId,
            vehicleToInheritFrom.fixedId,
            currentProduct.fixedId,
            !isLoggedOn
        );
    };

    return { setVehicleInheritanceFields };
};
